module.exports = require('./_hide');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.1/core-js/library/modules/_redefine.js
 ** module id = 43
 ** module chunks = 0
 **/